import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { ImageViewer } from "./ImageViewer";
import "./image-viewer.css";

const ViewerContext = createContext(null);
export const useImageViewer = () => useContext(ViewerContext);

export const ImageViewerProvider = ({ children }) => {
    const [gallery, setGallery] = useState(null);
    const opener = useRef(null);
    const { pathname } = useLocation();
    const close = useCallback(() => setGallery(null), []);
    const open = useCallback((images, index, trigger) => {
        if (!images.length) return;
        opener.current = trigger;
        setGallery({ slides: images.map((image, i) => ({ ...image, viewerId: i })), index });
    }, []);

    useEffect(close, [pathname, close]);
    const active = Boolean(gallery);
    useEffect(() => {
        if (!active) return;
        const lenis = window.__lenis;
        const wasStopped = lenis?.isStopped;
        const y = window.scrollY;
        const trigger = opener.current;
        lenis?.scrollTo(y, { immediate: true, force: true });
        lenis?.stop();
        document.body.classList.add("image-viewer-open");
        return () => {
            document.body.classList.remove("image-viewer-open");
            if (!wasStopped) lenis?.start();
            // Le pagine sottostanti non cambiano; niente salto al focus della miniatura.
            if (trigger?.isConnected) {
                lenis?.scrollTo(y, { immediate: true, force: true });
                window.scrollTo({ top: y, behavior: "instant" });
                trigger.focus({ preventScroll: true });
            }
        };
    }, [active]);

    return (
        <ViewerContext.Provider value={open}>
            {children}
            {gallery && <ImageViewer gallery={gallery} close={close} />}
        </ViewerContext.Provider>
    );
};